import { Box, Toolbar, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import Breadcrumbs from '../../components/@extended/Breadcrumbs';
// project import
import Drawer from './Drawer';
import Header from './Header';
import { Outlet } from 'react-router-dom';
import navigation from '../../menu-items';
// types
import { openDrawer } from '../../store/reducers/menu';
// material-ui
import { useTheme } from '@mui/material/styles';
import DashboardDefault from '../../pages/dashboard';
import { hideLoader, showLoader } from '../../../helpers/utils.js';
// import PersistentDrawerRight from "../../pages/TodaysActivity/TodaysActivit";

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useDispatch();

  const { drawerOpen } = useSelector((state) => state.menu);
  const { config } = useSelector((state) => state.userStore);

  // drawer toggler
  const [open, setOpen] = useState(drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
    localStorage.setItem("dragerMenu", open.toString());
  };

  // set media wise responsive drawer
  useEffect(() => {
    setOpen(!matchDownLG);
    dispatch(openDrawer({ drawerOpen: !matchDownLG }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  useEffect(() => {
    if (!config) showLoader();
    else hideLoader();
  }, [config]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />
      <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
      {/* <PersistentDrawerRight open={open} handleDrawerToggle={handleDrawerToggle} /> */}

      <Box
        component='main'
        sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 } }}
      >
        {/* <Toolbar /> */}
        {/* <Breadcrumbs navigation={navigation} title /> */}
        {/* <DashboardDefault /> */}

        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
